import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import CalculatorSuite from './components/CalculatorSuite';
import FeaturesSection from './components/FeaturesSection';
import CTASection from './components/CTASection';

const ROICalculatorSuite = () => {
  const [activeCalculator, setActiveCalculator] = useState(null);

  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  const handleCalculatorSelect = (calculatorId) => {
    setActiveCalculator(calculatorId);
    // Scroll to calculator section
    const calculatorSection = document.getElementById('calculator-suite');
    if (calculatorSection) {
      calculatorSection?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>ROI Calculator Suite - Value Demonstration Tools | Northstar Analytics</title>
        <meta 
          name="description" 
          content="Calculate your data strategy ROI with our interactive tools. Get compliance cost estimates, analytics readiness assessments, and personalized implementation roadmaps." 
        />
        <meta name="keywords" content="ROI calculator, data strategy, compliance costs, analytics readiness, business case, data transformation" />
        <meta property="og:title" content="ROI Calculator Suite - Value Demonstration Tools | Northstar Analytics" />
        <meta property="og:description" content="Quantify the financial impact of your data initiatives with our suite of interactive calculators. Get personalized insights and implementation roadmaps." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/roi-calculator-suite-value-demonstration-tools" />
      </Helmet>
      <Header />
      <main>
        {/* Hero Section */}
        <HeroSection onCalculatorSelect={handleCalculatorSelect} />

        {/* Calculator Suite */}
        <div id="calculator-suite">
          <CalculatorSuite />
        </div>

        {/* Features Section */}
        <FeaturesSection />

        {/* CTA Section */}
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default ROICalculatorSuite;